class TestTest {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (val) => typeof val === 'string' && val.trim() !== '',
      name: (val) => typeof val === 'string' && val.trim() !== '',
      measure: (val) => typeof val === 'string',
      description: (val) => typeof val === 'string',
      categoryId: (val) => {
        return (typeof val === 'string' && val.trim() !== '') || val === null;
      },
      healthId: (val) => {
        return (typeof val === 'string' && val.trim() !== '') || val === null;
      },
      sort: (val) => typeof val === 'number',
      reference: (val) => typeof val === 'object',
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid property ${property} in ${data.id}`);
      }

      this[property] = data[property];
    }

    for (const type of ['normal', 'standard', 'deviation']) {
      this.reference[type] = data.reference[type];
    }
  }
}

export default TestTest;
